// Carto `light_all` still answers HTTP 200 image/png without a key, but the
// PNG itself is watermarked "API KEY REQUIRED" / carto.com/basemapapikey.
// Esri Light Gray was chosen after visual compare (replacing GSI pale).
// Leaflet XYZ; Esri REST path is {z}/{y}/{x}.
export const SALONPAGE_MAP_TILE_URL =
  "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}";

// MapServer copyrightText: "Esri, HERE, Garmin, (c) OpenStreetMap contributors, and the GIS user community"
// Shown in SalonpageFooterInfo, not as a Leaflet overlay.
export const SALONPAGE_MAP_TILE_ESRI_HREF = "https://www.esri.com/";
export const SALONPAGE_MAP_TILE_ATTRIBUTION =
  "地図 © Esri, HERE, Garmin, © OpenStreetMap contributors, GIS user community";

// Service documents detailed coverage through level 16; z17+ tiles for Japan are empty placeholders.
export const SALONPAGE_MAP_TILE_MAX_NATIVE_ZOOM = 16;
